<div *ngIf="personProfileSkeletonLoading$ | async">Loading...</div>

<div *ngIf="personProfileSkeletonLoaded$ | async">
  <mat-accordion *ngIf="personProfileSkeleton$ | async as personProfileSkeleton">
    <mat-expansion-panel (opened)="personProfileOpened(personProfileSkeleton)">
      <mat-expansion-panel-header> Person Profile </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-audit-list
          #personProfileAuditList
          [personId]="personProfileSkeleton.personId"
          [loading]="personProfileAuditsLoading$ | async"
          [personProfileAudits]="personProfileAudits$ | async"
          (loadPersonProfile)="loadProfileAudits($event)"
          (nextPage)="nextProfileAuditPage($event)"
        ></sd-portal-person-profile-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Person Attributes </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            (opened)="personAttributeOpened(personAttributeSkeleton)"
            *ngFor="let personAttributeSkeleton of personProfileSkeleton.personAttributes"
          >
            <mat-expansion-panel-header>
              Attribute {{ personAttributeSkeleton.name }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-person-profile-attribute-audit-list
                #personAttributeAuditList
                [personAttribute]="personAttributeSkeleton"
                [loading]="personAttributeAuditsLoading$ | async"
                [personAttributeAudits]="personAttributeAudits$ | async"
                (loadPersonAttributeAudits)="loadPersonAttributeAudits($event)"
                (nextPage)="nextPersonAttributeAuditPage($event)"
              >
              </sd-portal-person-profile-attribute-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
        <ng-container
          *ngIf="
            !personProfileSkeleton.personAttributes ||
            personProfileSkeleton.personAttributes.length === 0
          "
        >
          There is no person attribute information available.
        </ng-container>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Employers </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let businessPersonSkeleton of personProfileSkeleton.businessPersons"
            (opened)="businessPersonOpened(businessPersonSkeleton)"
          >
            <mat-expansion-panel-header>
              {{ businessPersonSkeleton.customerName }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-person-profile-business-person-audit-list
                #businessPersonAuditList
                [businessPerson]="businessPersonSkeleton"
                [loading]="businessPersonAuditsLoading$ | async"
                [businessPersonAudits]="businessPersonAudits$ | async"
                (loadBusinessPersonAudits)="loadBusinessPersonAudits($event)"
                (nextPage)="nextBusinessPersonAuditPage($event)"
              >
              </sd-portal-person-profile-business-person-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel (opened)="passengerOpened(personProfileSkeleton.passenger)">
      <mat-expansion-panel-header> Passenger </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-passenger-audit-list
          #passengerAuditList
          [passenger]="personProfileSkeleton.passenger"
          [loading]="passengerAuditsLoading$ | async"
          [passengerAudits]="passengerAudits$ | async"
          (loadPassengerAudits)="loadPassengerAudits($event)"
          (nextPage)="nextPassengerAuditPage($event)"
        ></sd-portal-person-profile-passenger-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Contact Information </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-contact-info-audit-list
          #contactInfoAuditList
          [contactInfo]="personProfileSkeleton.contactInfo"
          [addressAudits]="addressAudits$ | async"
          [addressAuditsLoading]="addressAuditsLoading$ | async"
          (loadAddressAudits)="loadAddressAudits($event)"
          (nextAddressAuditPage)="nextAddressAuditPage($event)"
          [phoneNumberAudits]="phoneNumberAudits$ | async"
          [phoneNumberAuditsLoading]="phoneNumberAuditsLoading$ | async"
          (loadPhoneNumberAudits)="loadPhoneNumberAudits($event)"
          (nextPhoneNumberAuditPage)="nextPhoneNumberAuditPage($event)"
          [emailAddressAudits]="emailAddressAudits$ | async"
          [emailAddressAuditsLoading]="emailAddressAuditsLoading$ | async"
          (loadEmailAddressAudits)="loadEmailAddressAudits($event)"
          (nextEmailAddressAuditsPage)="nextEmailAddressAuditPage($event)"
        >
        </sd-portal-person-profile-contact-info-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Emergency Contacts </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            (opened)="emergencyContactOpened(emergencyContactSkeleton)"
            *ngFor="let emergencyContactSkeleton of personProfileSkeleton.emergencyContacts"
          >
            <mat-expansion-panel-header>
              {{ emergencyContactSkeleton.contactName }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-person-profile-emergency-contact-audit-list
                #emergencyContactAuditList
                [emergencyContact]="emergencyContactSkeleton"
                [loading]="emergencyContactAuditsLoading$ | async"
                [emergencyContactAudits]="emergencyContactAudits$ | async"
                (loadEmergencyContactAudits)="loadEmergencyContactAudits($event)"
                (nextPage)="nextEmergencyContactAuditPage($event)"
                [emergencyContactPhoneNumberAuditsLoading]="
                  emergencyContactPhoneNumberAuditsLoading$ | async
                "
                [emergencyContactPhoneNumberAudits]="emergencyContactPhoneNumberAudits$ | async"
                (loadEmergencyContactPhoneNumberAudits)="
                  loadEmergencyContactPhoneNumberAudits($event)
                "
                (nextEmergencyContactPhoneNumberAuditsPage)="
                  nextEmergencyContactPhoneNumberAuditsPage($event)
                "
              >
              </sd-portal-person-profile-emergency-contact-audit-list>
            </ng-template>
          </mat-expansion-panel>
          <ng-container
            *ngIf="
              !personProfileSkeleton.emergencyContacts ||
              personProfileSkeleton.emergencyContacts.length === 0
            "
          >
            There is no emergency contact information available.
          </ng-container>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Executive Admins </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let executiveAssociateSkeleton of personProfileSkeleton.executiveAssociates"
            (opened)="executiveAssociateOpened(executiveAssociateSkeleton)"
          >
            <mat-expansion-panel-header>
              {{ executiveAssociateSkeleton.name }}
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-person-profile-executive-associate-audit-list
                #executiveAssociateAuditList
                [executiveAssociate]="executiveAssociateSkeleton"
                [loading]="executiveAssociateAuditsLoading$ | async"
                [executiveAssociateAudits]="executiveAssociateAudits$ | async"
                (loadExecutiveAssociateAudits)="loadExecutiveAssociateAudits($event)"
                (nextPage)="nextExecutiveAssociateAuditPage($event)"
                [executiveAssociatePhoneNumberAuditsLoading]="
                  executiveAssociatePhoneNumberAuditsLoading$ | async
                "
                [executiveAssociatePhoneNumberAudits]="executiveAssociatePhoneNumberAudits$ | async"
                (loadExecutiveAssociatePhoneNumberAudits)="
                  loadExecutiveAssociatePhoneNumberAudits($event)
                "
                (nextExecutiveAssociatePhoneNumberAuditsPage)="
                  nextExecutiveAssociatePhoneNumberAuditsPage($event)
                "
                [executiveAssociateEmailAuditsLoading]="
                  executiveAssociateEmailAuditsLoading$ | async
                "
                [executiveAssociateEmailAudits]="executiveAssociateEmailAudits$ | async"
                (loadExecutiveAssociateEmailAudits)="loadExecutiveAssociateEmailAudits($event)"
                (nextExecutiveAssociateEmailAuditsPage)="
                  nextExecutiveAssociateEmailAuditsPage($event)
                "
              >
              </sd-portal-person-profile-executive-associate-audit-list>
            </ng-template>
          </mat-expansion-panel>
          <ng-container
            *ngIf="
              !personProfileSkeleton.executiveAssociates ||
              personProfileSkeleton.executiveAssociates.length === 0
            "
          >
            There is no executive associate information available.
          </ng-container>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="
        personProfileSkeleton.crewMemberTypeRatings &&
        personProfileSkeleton.crewMemberTypeRatings.length > 0
      "
    >
      <mat-expansion-panel-header> AC Type Ratings </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <ng-container *ngIf="crewMemberTypeRatingTypes$ | async as crewMemberTypeRatingTypes">
          <mat-accordion>
            <mat-expansion-panel
              *ngFor="
                let crewMemberTypeRatingSkeleton of personProfileSkeleton.crewMemberTypeRatings
              "
              (opened)="crewMemberTypeRatingOpened(crewMemberTypeRatingSkeleton)"
            >
              <mat-expansion-panel-header>
                {{
                  getCrewMemberTypeRatingTypeName(
                    crewMemberTypeRatingTypes,
                    crewMemberTypeRatingSkeleton.aircraftTypeRatingId
                  )
                }}
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <sd-portal-person-profile-crew-member-type-rating-audit-list
                  [crewMemberTypeRating]="crewMemberTypeRatingSkeleton"
                  [loading]="crewMemberTypeRatingAuditsLoading$ | async"
                  [crewMemberTypeRatingAudits]="crewMemberTypeRatingAudits$ | async"
                  (loadCrewMemberTypeRatingAudits)="loadCrewMemberTypeRatingAudits($event)"
                  (nextPage)="nextCrewMemberTypeRatingAuditsPage($event)"
                >
                </sd-portal-person-profile-crew-member-type-rating-audit-list>
              </ng-template>
            </mat-expansion-panel>
            <ng-container
              *ngIf="
                !personProfileSkeleton.preferencesHotel ||
                personProfileSkeleton.preferencesHotel.length === 0
              "
            >
              There is AC type rating information available.
            </ng-container>
          </mat-accordion>
        </ng-container>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Preferences </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-expansion-panel>
          <mat-expansion-panel-header> Catering </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <mat-accordion>
              <mat-expansion-panel
                (opened)="preferenceOpened(preferenceSkeleton)"
                *ngFor="let preferenceSkeleton of personProfileSkeleton.preferencesCatering"
              >
                <mat-expansion-panel-header>
                  {{ preferenceSkeleton.preferenceType }} Preference
                  <ng-container *ngIf="preferenceSkeleton.isDeleted">(Deleted) </ng-container>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-person-profile-preference-audit-list
                    #preferenceCateringAuditList
                    [preference]="preferenceSkeleton"
                    [loading]="preferenceCateringAuditsLoading$ | async"
                    [preferenceAudits]="preferenceCateringAudits$ | async"
                    (loadPreferenceAudits)="loadPreferenceCateringAudits($event)"
                    (nextPage)="nextPreferenceCateringAuditsPage($event)"
                  >
                  </sd-portal-person-profile-preference-audit-list>
                </ng-template>
              </mat-expansion-panel>
              <ng-container
                *ngIf="
                  !personProfileSkeleton.preferencesCatering ||
                  personProfileSkeleton.preferencesCatering.length === 0
                "
              >
                There is no catering preference information available.
              </ng-container>
            </mat-accordion>
          </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header> Ground Transportation </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <mat-accordion>
              <mat-expansion-panel
                (opened)="preferenceOpened(preferenceSkeleton)"
                *ngFor="
                  let preferenceSkeleton of personProfileSkeleton.preferencesGroundTransportation
                "
              >
                <mat-expansion-panel-header>
                  {{ preferenceSkeleton.preferenceType }} Preference
                  <ng-template *ngIf="preferenceSkeleton.isDeleted">(Deleted) </ng-template>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-person-profile-preference-audit-list
                    #preferencesGroundTransportation
                    [preference]="preferenceSkeleton"
                    [loading]="preferenceGroundTransportationAuditsLoading$ | async"
                    [preferenceAudits]="preferenceGroundTransportationAudits$ | async"
                    (loadPreferenceAudits)="loadPreferenceGroundTransportationAudits($event)"
                    (nextPage)="nextPreferenceGroundTransportationAuditsPage($event)"
                  >
                  </sd-portal-person-profile-preference-audit-list>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
            <ng-container
              *ngIf="
                !personProfileSkeleton.preferencesGroundTransportation ||
                personProfileSkeleton.preferencesGroundTransportation.length === 0
              "
            >
              There is no ground transportation preference information available.
            </ng-container>
          </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header> Hotel </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <mat-accordion>
              <mat-expansion-panel
                (opened)="preferenceOpened(preferenceSkeleton)"
                *ngFor="let preferenceSkeleton of personProfileSkeleton.preferencesHotel"
              >
                <mat-expansion-panel-header>
                  {{ preferenceSkeleton.preferenceType }} Preference
                  <ng-template *ngIf="preferenceSkeleton.isDeleted">(Deleted) </ng-template>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-person-profile-preference-audit-list
                    #preferenceHotel
                    [preference]="preferenceSkeleton"
                    [loading]="preferenceHotelAuditsLoading$ | async"
                    [preferenceAudits]="preferenceHotelAudits$ | async"
                    (loadPreferenceAudits)="loadPreferenceHotelAudits($event)"
                    (nextPage)="nextPreferenceHotelAuditsPage($event)"
                  >
                  </sd-portal-person-profile-preference-audit-list>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
            <ng-container
              *ngIf="
                !personProfileSkeleton.preferencesHotel ||
                personProfileSkeleton.preferencesHotel.length === 0
              "
            >
              There is no hotel preference information available.
            </ng-container>
          </ng-template>
        </mat-expansion-panel>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="personProfileSkeleton.staffInfoId"
      (opened)="staffInfoOpened(personProfileSkeleton.staffInfoId)"
    >
      <mat-expansion-panel-header> Staff Details </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-staff-detail-audit-list
          #staffDetailAuditList
          [staffInfoId]="personProfileSkeleton.staffInfoId"
          [staffInfoAudits]="staffInfoAudits$ | async"
          [loading]="staffInfoAuditsLoading$ | async"
          (loadStaffInfoAudits)="loadStaffInfoAudits($event)"
          (nextPage)="nextStaffInfoAuditPage($event)"
        >
        </sd-portal-person-profile-staff-detail-audit-list>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Staff Groups </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-expansion-panel
          *ngFor="let personProfileSkeleton of personProfileSkeleton.personStaffGroups"
          (opened)="personStaffGroupOpened(personProfileSkeleton.personStaffGroupId)"
        >
          <mat-expansion-panel-header>
            {{ personProfileSkeleton.staffGroupName }}
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <sd-portal-person-profile-person-staff-groups-audit-list
              [personStaffGroup]="personProfileSkeleton"
              [personStaffGroupAudits]="personStaffGroupAudits$ | async"
              [loading]="personStaffGroupAuditsLoading$ | async"
              (loadPersonStaffGroupAudits)="loadPersonStaffGroupAudits($event)"
              (nextPage)="nextPersonStaffGroupAuditPage($event)"
            >
            </sd-portal-person-profile-person-staff-groups-audit-list>
          </ng-template>
        </mat-expansion-panel>
        <ng-container
          *ngIf="
            !personProfileSkeleton.personStaffGroups ||
            personProfileSkeleton.personStaffGroups.length === 0
          "
        >
          There is no staff groups available.
        </ng-container>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header> Tax Info </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-expansion-panel
          *ngFor="let taxInfoSkeleton of personProfileSkeleton.taxInfos"
          (opened)="taxInfoOpened(taxInfoSkeleton.taxInfoId)"
        >
          <mat-expansion-panel-header>
            Tax Info #{{ taxInfoSkeleton.taxInfoId }} from {{ taxInfoSkeleton.startDate }} to
            {{ taxInfoSkeleton.endDate }}
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <sd-portal-person-profile-tax-info-audit-list
              [taxInfo]="taxInfoSkeleton"
              [taxInfoAudits]="taxInfoAudits$ | async"
              [loading]="taxInfoAuditsLoading$ | async"
              (loadTaxInfoAudits)="loadTaxInfoAudits($event)"
              (nextPage)="nextTaxInfoAuditPage($event)"
            >
            </sd-portal-person-profile-tax-info-audit-list>
          </ng-template>
        </mat-expansion-panel>
        <ng-container
          *ngIf="!personProfileSkeleton.taxInfos || personProfileSkeleton.taxInfos.length === 0"
        >
          There is no tax information available.
        </ng-container>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
